import React, { useContext, useState, useEffect } from "react";
import ReactGA from "react-ga";
import { sendAnswer } from "../actions/answerQuestion";
import SurveyContext from "./SurveyContext";
const CurrentQuestionContext = React.createContext();

const CurrentQuestionProvider = ({ children }) => {
  const survey = useContext(SurveyContext).surveyData;
  const isAlreadyAnswered = useContext(SurveyContext).isAlreadyAnswered;
  const userId = useContext(SurveyContext).userId;
  const [question, setCurrentQuestion] = useState(survey.screens[0]);
  const [currQuestionIndex, setCurrQuestionIndex] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [isSuccessText, setIsSuccessText] = useState(false);

  useEffect(() => {
    if (isAlreadyAnswered && survey.screens.length > 1) {
      setCurrentQuestion(survey.screens[survey.screens.length - 1]);
    }
  }, [isAlreadyAnswered, survey.screens.length]);

  useEffect(() => {
    if (survey.screens.length > 1) {
      setCurrentQuestion(survey.screens[0]);
    }
  }, [survey.screens.length]);

  const answerQuestion = async (userAnswer, nextQuestionIndex, timer) => {
    let isFinish = false;

    if (nextQuestionIndex === survey.screens.length - 2) {
      isFinish = true;
      if (storageAvailable()) handleLastQuestionAnswered();
    }
    if (nextQuestionIndex === 1) {
      ReactGA.set({
        dimension1: userId,
      });
    }

    ReactGA.event({
      category: "question_answer",
      action: "user_sent_answer",
      label: `${survey.surveyKey}/${question.screenKey}`,
    });

    setLoading(true);
    await sendAnswer(
      survey.surveyKey,
      question.screenKey,
      userAnswer,
      isFinish,
      timer,
      userId
    );

    // timeout for fade
    await new Promise((r) => setTimeout(r, 500));
    if (survey.screens.length >= nextQuestionIndex) {
      setIsSuccessText(true);
      // timeout for fade
      await new Promise((r) => setTimeout(r, 500));
      setIsSuccessText(false);
      setLoading(false);
      changeQuestion(nextQuestionIndex);
    }
  };

  function storageAvailable() {
    var test = "test";
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  const handleLastQuestionAnswered = () => {
    window.localStorage.setItem("dateAnswered", new Date());
    window.localStorage.setItem("surveyKey", survey.surveyKey);
  };

  const changeQuestion = (newQuestionIndex) => {
    setCurrQuestionIndex(newQuestionIndex);
    setCurrentQuestion(survey.screens[newQuestionIndex]);
  };

  const setNextQuestion = async (userAnswer, timer) => {
    const nextScreenIndex = currQuestionIndex + 1;
    await answerQuestion(userAnswer, nextScreenIndex, timer);
  };

  const setSpecificQuestion = async (specificScreenKey, userAnswer, timer) => {
    const nextScreenIndex = survey.screens.findIndex(
      (x) => x.screenKey === specificScreenKey
    );
    await answerQuestion(userAnswer, nextScreenIndex, timer);
  };

  return (
    <CurrentQuestionContext.Provider
      value={{
        question,
        setNextQuestion,
        currQuestionIndex,
        setSpecificQuestion,
        isLoading,
        isSuccessText,
        setIsSuccessText,
      }}
    >
      {children}
    </CurrentQuestionContext.Provider>
  );
};

export default CurrentQuestionContext;
export { CurrentQuestionProvider };
